import { DesktopLiveBidPanel } from '@liveauctioneers/hammer-ui-liveauctioneers/desktopLiveBidPanel';
import { getItemSummaryCatalogId } from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppSelector } from '@/redux/hooks';
import { useGetBidCanvasBuyerData } from '@/components/ItemBidding/components/BidCanvasContainer/hooks/useGetBidCanvasBuyerData';
import { useGetBiddingConsoleCallbacks } from './hooks/useGetBiddingConsoleCallbacks';
import { useGetBiddingConsoleCatalogData } from './hooks/useGetBiddingConsoleCatalogData';
import { useGetBiddingConsoleItemData } from './hooks/useGetBiddingConsoleItemData';

type Props = {
    itemId: number;
    selectedCurrency?: string;
};

export const BidPanel = ({ itemId, selectedCurrency }: Props) => {
    const buyer = useGetBidCanvasBuyerData({ isBiddingConsole: true, itemId });
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const catalog = useGetBiddingConsoleCatalogData({ itemId, selectedCurrency });
    const callbacks = useGetBiddingConsoleCallbacks({ catalogId, itemId });
    const item = useGetBiddingConsoleItemData({ itemId });

    return (
        <DesktopLiveBidPanel
            buyer={buyer}
            callbacks={callbacks}
            catalog={catalog}
            item={item}
            topBorderOnly
        />
    );
};
